export const INVITE_EMAIL = '@ACCOUNT_LIST/INVITE_EMAIL'
export const ACCOUNT_LIST = '@ACCOUNT_LIST/ACCOUNT_LIST'
export const POST_ACCEPT_INVITE_MEMBER = '@ACCOUNT_LIST/POST_ACCEPT_INVITE_MEMBER'
export const CHANGE_EMAIL = '@ACCOUNT_LIST/CHANGE_EMAIL'
export const VERIFY_CHANGE_EMAIL = '@ACCOUNT_LIST/VERIFY_CHANGE_EMAIL'
export const DELETE_ACCOUNT = '@ACCOUNT_LIST/DELETE_ACCOUNT'
